import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=ee1afe0c&"
import script from "./Forget.vue?vue&type=script&lang=ts&"
export * from "./Forget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports